import * as React from "react";
import { observer, inject } from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";

import { ConfigurationStore } from "../../stores/ConfigurationStore";
import { CustomerStore } from "../../stores/CustomerStore";
import { Customer, Contact } from "src/model/Customer";

import InvolvementComponent from "./InvolvementComponent";

export interface Props {
    customerStore?: CustomerStore;
    configurationStore?: ConfigurationStore;
}
export interface State {
    currentTab: string;
}

// @inject("configurationStore")
@inject("customerStore")
@observer
export default class Involvement extends React.Component<Props, State> {
    render() {
        const { customerStore } = this.props;
        if (!customerStore) {
            throw new Error(" ** No Customer Store **");
        }

        const customer = customerStore.customer;
        if (!customer) {
            return {};
        }

        const involvement = (customer as Contact).involvement;

        return (
            <>
                <div className="card shadow mb-4">
                    <div className="card-header">Current Involvement</div>
                    <div className="card-body">
                        <InvolvementComponent
                            keyField="currentInvolvement"
                            currentInvolvement={true}
                            defaultTab="all"
                            involvements={involvement}
                            search={false}
                        />
                    </div>
                </div>
                <div className="card shadow">
                    <div className="card-header">Past Involvement</div>
                    <div className="card-body">
                        <InvolvementComponent
                            keyField="pastInvolvement"
                            currentInvolvement={false}
                            defaultTab="owner"
                            involvements={involvement}
                            search={true}
                            needPagination={true}
                        />
                    </div>
                </div>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/customer/Involvement.tsx